
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import type { CandidateInteraction } from "@/components/candidates/types";

export function useCandidateInteractions(candidateId: string) {
  return useQuery({
    queryKey: ["candidate-interactions", candidateId],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("candidate_interactions")
        .select("*")
        .eq("candidate_id", candidateId)
        .order("created_at", { ascending: false });

      if (error) {
        throw error;
      }

      return data as CandidateInteraction[];
    },
  });
}
